<div>
  <app-event-management-section-heading
    [id]="id"
    [title]="'describe_your_event' | t"
    [description]="'describe_your_event_description' | t"
  ></app-event-management-section-heading>

  <app-input-row
    [label]="'event_form_status' | t"
    [labelDescription]="'event_form_status_description' | t"
  >
    <app-select
      [fc]="innerForm.controls.event_status_id"
      [options]="eventStatusOptions"
      [emptyOption]="false"
    >
    </app-select>
    <div class="text-small text-color-light">
      {{ eventStatusDescription }}
    </div>
  </app-input-row>

  <app-input-row
    [label]="'event_form_organizer' | t"
    [labelDescription]="'event_form_organizer_description' | t"
  >
    <app-select
      [fc]="innerForm.controls.event_organization_id"
      [options]="organizationOptions"
      [emptyOption]="false"
    >
    </app-select>
  </app-input-row>

  <app-input-row
    [label]="'event_form_event_title' | t"
    [labelDescription]="'event_form_event_title_description' | t"
  >
    <app-input
      [fc]="innerForm.controls.event_name"
      [placeholder]="'event_form_event_title_placeholder' | t"
    >
    </app-input>
  </app-input-row>

  <app-input-row
    [label]="'event_form_start_datetime' | t"
    [labelDescription]="'event_form_start_datetime_description' | t"
  >
    <div class="row">
      <div class="col-4">
        <app-date-input
          [fc]="innerForm.controls.event_start_date"
        ></app-date-input>
      </div>
      <div class="col-3">
        <app-time-input
          [fc]="innerForm.controls.event_start_time"
        ></app-time-input>
      </div>
    </div>
  </app-input-row>

  <app-input-row
    [label]="'event_form_finish_datetime' | t"
    [labelDescription]="'event_form_finish_datetime_description' | t"
  >
    <div class="row">
      <div class="col-4">
        <app-date-input
          [minDate]="minEventFinishDate"
          [fc]="innerForm.controls.event_finish_date"
        ></app-date-input>
      </div>
      <div class="col-3">
        <app-time-input
          [fc]="innerForm.controls.event_finish_time"
        ></app-time-input>
      </div>
    </div>
  </app-input-row>

  <app-input-row
    [label]="'event_form_short_description' | t"
    [labelDescription]="'event_form_short_description_description' | t"
  >
    <app-textarea
      [fc]="innerForm.controls.event_short_description"
      [maxLength]="eventShortDescriptionMaxLength"
      rows="5"
      [placeholder]="'event_form_short_description_placeholder' | t"
    >
    </app-textarea>
    <span class="text-color-light text-small"
      >{{ eventShortDescriptionCharactersLeft }}
      {{ "event_form_characters_left" | t }}</span
    >
  </app-input-row>

  <app-input-row
    [label]="'event_form_description' | t"
    [labelDescription]="'event_form_description_description' | t"
  >
    <div class="basic-info__text-editor-wrapper">
      <app-text-editor
        class="basic-info__text-editor"
        [fc]="innerForm.controls.event_description"
        [placeholder]="'event_form_description_placeholder' | t"
      >
      </app-text-editor>
    </div>
  </app-input-row>

  <app-input-row
    [label]="'event_form_event_image' | t"
    [labelDescription]="'event_form_event_image_description' | t"
  >
    <app-img-crop
      [fc]="innerForm.controls.event_cover_photo"
      [aspectRatio]="16 / 9"
    ></app-img-crop>
  </app-input-row>
</div>
